import React from "react";

export interface KeyboardShortcut {
  key: string;
  /** When true, matches Cmd on Mac or Ctrl on Windows/Linux. */
  modKey?: boolean;
  metaKey?: boolean;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  altKey?: boolean;
  handler: (event: KeyboardEvent) => void;
  description?: string;
}

export const useKeyboardShortcuts = (shortcuts: KeyboardShortcut[]) => {
  React.useEffect(() => {
    const mac = isMac();

    const handleKeyDown = (event: KeyboardEvent) => {
      for (const shortcut of shortcuts) {
        const keyMatches = event.key === shortcut.key;

        let metaMatches: boolean;
        let ctrlMatches: boolean;
        if (shortcut.modKey !== undefined) {
          if (mac) {
            metaMatches = event.metaKey === shortcut.modKey;
            ctrlMatches = !event.ctrlKey;
          } else {
            ctrlMatches = event.ctrlKey === shortcut.modKey;
            metaMatches = !event.metaKey;
          }
        } else {
          metaMatches = shortcut.metaKey === undefined || event.metaKey === shortcut.metaKey;
          ctrlMatches = shortcut.ctrlKey === undefined || event.ctrlKey === shortcut.ctrlKey;
        }

        const shiftMatches = shortcut.shiftKey === undefined || event.shiftKey === shortcut.shiftKey;
        const altMatches = shortcut.altKey === undefined || event.altKey === shortcut.altKey;

        if (keyMatches && metaMatches && ctrlMatches && shiftMatches && altMatches) {
          event.preventDefault();
          shortcut.handler(event);
          break;
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [shortcuts]);
};

// Platform-aware helper to detect Mac vs Windows/Linux
export const isMac = () => {
  return typeof window !== "undefined" && navigator.platform.toUpperCase().indexOf("MAC") >= 0;
};

